import React, {useState, useEffect, useRef} from 'react';
import InfiniteScroll from "react-infinite-scroller";
import {DFiltersConfigParam, FiltersConfigParam, isMobile, jsonToFormData, useGlobalState} from "../state";
import ReactHtmlParser, {convertNodeToElement} from "react-html-parser";
import {InView} from "react-intersection-observer";
import {useInfiniteQuery} from "@tanstack/react-query";
import useLocalStorage from "use-local-storage";

export default function DiamondsList(props) {
    const [listHeaderHTML] = useState(document.querySelector('#o-list-header-block')
        ? document.querySelector('#o-list-header-block').innerHTML
        : ""
    );
    const [itemsCount, setItemsCount] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isFirstLoadFinished, setIsFirstLoadFinished] = useGlobalState('firstLoadFinished');

    const [byoType] = useGlobalState('byoType');
    const [byoStep] = useGlobalState('byoStep');
    const [byoSp] = useGlobalState('byoSp');
    const [dType] = useGlobalState('dType');
    const [isGrid] = useGlobalState('isGrid');
    const [sortBy, setSortBy] = useGlobalState('sortBy');
    const [sortDirection, setSortDirection] = useGlobalState('sortDirection');
    const [dShape] = useGlobalState('dShape');
    const [BYOSelectedSettingID] = useGlobalState('BYOSelectedSettingID');
    const [dfiltersConfig, setDFiltersConfig] = useGlobalState('dfilters');
    const [filtersConfig, setFiltersConfig] = useGlobalState('filters');
    const [isFromDetailViewNavigation, setIsFromDetailViewNavigation] = useLocalStorage('isFromDetailViewNavigation', 'false');

    const scrollRef = useRef(null);

    useEffect(() => {
        if(isFromDetailViewNavigation === 'false') {
            scrollRef.current.pageLoaded = 0;
            // scrollRef.current.scrollTo(0, 0);
            window.localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE');
        }
        else {
            setIsFromDetailViewNavigation('false');
        }
    }, [])

    /** fetch new products */
    const diamondListResult = useInfiniteQuery(['diamonds', dType, dShape, isGrid, sortBy, sortDirection, dfiltersConfig, filtersConfig], async ({ signal, pageParam = 0 }) => {
        if(pageParam == null) pageParam = 0;
        scrollRef.current.pageLoaded = pageParam;
        return await fetchDisplayBlockImpl(signal, pageParam !== 0, pageParam);
    }, {
        // refetchOnMount: true,
        getNextPageParam: (lastPage, pages) => {
            return lastPage ? lastPage.pageNumber + 1 : 0;
        },
        getPreviousPageParam: (lastPage, pages) => {
            if(!lastPage) return 0;
            return lastPage.pageNumber - 1 < 0 ? 0 : lastPage.pageNumber - 1;
        }
    })

    const onSortListHeaderClick = (_sortBy) => {
        setSortBy(_sortBy);
        setSortDirection(sortDirection !== 'desc' ? 'desc' : 'asc');
    }

    const onLazyLoadVideoInView = (inView, entry) => {
        if (entry.isIntersecting) {
            const video = entry.target.firstChild;
            for (const source in video.children) {
                const videoSource = video.children[source];
                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    videoSource.src = videoSource.dataset.src;
                }
            }
            video.load();
            video.classList.remove("lazy");
        }
    }

    return (
        <InfiniteScroll
            ref={scrollRef}
            initialLoad={false}
            pageStart={0}
            threshold={isMobile() ? (isGrid ? 1500 : 1000) : 600}
            loadMore={(page) => {
                if(!diamondListResult.isFetchingNextPage && !diamondListResult.isFetching) {
                    diamondListResult.fetchNextPage()
                }
            }}
            hasMore={hasMore}
            loader={<div style={{display: 'flex', justifyContent: "center"}}><div className="loader"/></div>}
        >
            {(byoType !== 'gemstone' && byoType !== 'naturalfancycolored')
                ? <>
                    <div className="col-sm-12" align="center">
                        <h5 style={{textAlign: "center"}}>total <span id="itemsCount">{itemsCount}</span> items</h5>
                    </div>
                    {isGrid &&
                        <div className="container" id="gridContent">
                            {diamondListResult.data && diamondListResult.data.pages && diamondListResult.data.pages.map((page, i) => (
                                <React.Fragment key={i}>
                                    {ReactHtmlParser(page.displayBlock, {
                                        transform: (node) => transformNode(node)
                                    })}
                                </React.Fragment>
                            ))}
                        </div>
                    }
                    {!isGrid &&
                        <div className="container" id="listContent">
                            <table id="sorting" className="table table-striped table-bordered" style={{margin: "50px 0"}}>
                                <thead>
                                <tr id="appendHeader">
                                    {ReactHtmlParser(listHeaderHTML, {
                                        transform: (node) => transformNode(node)
                                    })}
                                </tr>
                                </thead>
                                <tbody id="listTable">
                                {diamondListResult.data && diamondListResult.data.pages && diamondListResult.data.pages.map((page, i) => (
                                    <React.Fragment key={i}>
                                        {ReactHtmlParser(page.displayBlock, {
                                            transform: (node) => transformNode(node)
                                        })}
                                    </React.Fragment>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    }
                  </>
                : <div className="container">
                    <div id="products" className="row list-group gemstone-products">
                        {diamondListResult.data && diamondListResult.data.pages && diamondListResult.data.pages.map((page, i) => (
                            <React.Fragment key={i}>
                                {ReactHtmlParser(page.displayBlock, {
                                    transform: (node) => transformNode(node)
                                })}
                            </React.Fragment>
                        ))}
                    </div>
                  </div>
            }
        </InfiniteScroll>
    )

    function transformNode(node, isChild = false) {
        if(node.attribs && node.attribs.class && node.attribs.class.includes("item")) {
            return <div {...node.attribs} style={{}} onClick={() => setIsFromDetailViewNavigation('true')}>
                {node.children.map(child => transformNode(child, true))}
            </div>
        }
        //diamond images
        if(node.type === 'tag' && node.name === 'img' && node.attribs.class && node.attribs.class.includes('img-responsive')) {
            return <img {...node.attribs}
                        style={{opacity: 0, transition: "opacity 0.3s ease-in", aspectRatio: node.attribs.src.includes('ZURI') ? null : "1", width: "100%", objectFit: "contain"}}
                        onLoad={e => e.currentTarget.style.opacity = '1'}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = node.attribs.onerror.replace('this.onerror=null;this.src="', '').replace('"', '').replace(';', '')
                        }}/>
        }
        //list headers
        if(node.type === 'tag' && node.name === 'th' && node.attribs.id && node.attribs.id.includes('-header')) {
            return <th id={node.attribs.id} onClick={() => onSortListHeaderClick(node.attribs.id.replace('-header', ''))} style={{cursor: "pointer", display: node.attribs.style && node.attribs.style.includes('none') ? 'none' : 'table-cell'}}>
                        {node.children[0].data}
                        <i className={`fa fa-chevron-${sortBy === node.attribs.id.replace('-header', '') && sortDirection === 'desc' ? 'up' : 'down'}`}/>
                   </th>
        }
        //gemstone videos (lazy-load)
        if(node.type === 'tag' && node.name === 'video' && node.attribs.class && node.attribs.class.includes('lazy')) {
            return  <InView as="div" onChange={onLazyLoadVideoInView} triggerOnce>
                        <video className="thevideo lazy gemstone-video" style={{opacity: 0, transition: 'opacity 0.3s ease-in'}} loop playsInline muted autoPlay={isMobile()}
                               onCanPlay={(e) => e.currentTarget.style.opacity = '1'}
                               onMouseOver={(e) => e.currentTarget.play()}
                               onMouseOut={(e) => {e.currentTarget.pause(); e.currentTarget.currentTime = 0;}}>
                            <source {...node.children[1].attribs}/>
                            Your browser does not support the video tag
                        </video>
                    </InView>
        }

        if(isChild) {
            const el = convertNodeToElement(node);
            if(node.children && !(node.name === 'img' || node.name === 'input')) {
                el.props.children = node.children.map((child) => transformNode(child, true))
            }
            return el;
        }
    }

    async function fetchDisplayBlockImpl(abortSignal, isNextPageRequest = false, pageNumber = 0) {
        if(!isNextPageRequest) {
            setItemsCount(0);
            setHasMore(true);
        }

        const res = await fetch(`/build_your_own/${byoStep}/api/update_api.php`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
            signal: abortSignal,
            body: new URLSearchParams(jsonToFormData({
                byoType: byoType,
                byosp: byoSp,
                dtype: dType,
                ssid: BYOSelectedSettingID,
                isgrid: isGrid,
                sortBy: sortBy,
                sortDirection: sortDirection,
                page: pageNumber,
                dshape: dShape,
                dfilters: DFiltersConfigParam.encode(dfiltersConfig),
                filters: FiltersConfigParam.encode(filtersConfig),
                cache:'ew'
            }))
        });
        const data = await res.json();
        let _displayBlock = "";
        if(!isNextPageRequest) {
            if(data.itemsDisplayBlock === "" || data.itemsDisplayBlock == null) {
                // _displayBlock = '<div id=\"no-diamonds-found\" style=\"color: black; width: 100%; text-align: center; padding: 16px 0; font-size: 16px;\">' +
                //     'DUE TO EXCLUSIVITY ONLINE DISTRIBUTION AGREEMENTS BETWEEN RAPNET DIAMOND NETWORK VENDORS AND FOUR ONLINE RETAILERS, WE ARE NOT ALLOWED TO POST ON OUR SITE CERTAIN DIAMOND INVENTORY.<br>\n' +
                //     'This exclusivity agreement is causing you the buyer to pay more than you should for diamonds.<br>\n' +
                //     'Please email us the diamond you are looking for or the diamond that you found on any other sites and we will order it directly from the manufacturer for you at a lower price.<br>\n' +
                //     'The savings will go directly to your pocket.<br>\n' +
                //     'Please email us to diamonds.questions@theartofjewels.com  OR call us to 1-888-391-1130' +
                //     '<br><br>' +
                //     '<span style=\'color: #6FBF98;\'>How to Buy Your Desired Diamond at The Lowest Price Possible Even If You Can Not Find It On Our Website?</span><br>' +
                //     '<a href=\"/static.php?page=about-us/diamond-industry-secrets#how-to-buy-desired-diamond\"><button class=\"btn btn-more-select with-color\">CLICK HERE</button></a>' +
                // '</div>';
            } else {
                _displayBlock = data.itemsDisplayBlock;
            }

            await setDFiltersConfig(data.dfilters);
            await setFiltersConfig(data.filters);

            if(!isFirstLoadFinished) {
                await setIsFirstLoadFinished(true);
            }
        } else {
            if(data.itemsDisplayBlock !== "" && data.itemsDisplayBlock != null) {
                _displayBlock = data.itemsDisplayBlock;
            }
        }
        setItemsCount(data.itemsCount);
        setHasMore(data.itemsDisplayBlock !== "");
        return {
            pageNumber: pageNumber,
            displayBlock: _displayBlock
        };
    }
}
